import state from './logDocumentState'
import actions from './logDocumentActions'
import mutations from './logDocumentMutations'
import getters from './logDocumentGetters'

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
